import { FormikProps } from "formik";
import { PersonalDetailsDto } from "../../Models";
import { SearchButton, StyledGrid, StyledTextField } from "./StyledComponents";
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';

interface IdentityVerificationProps {
    formik: FormikProps<PersonalDetailsDto>;
    onSearch: () => void;
    disableSearch: boolean;
    loading: boolean;
  }
  
 export const IdentityVerification: React.FC<IdentityVerificationProps> = ({
    formik,
    onSearch,
    disableSearch,
    loading,
  }) => (
    <StyledGrid item xs={12} md={6}>
      <StyledTextField
        fullWidth
        id="identityNumber"
        name="identityNumber"
        label="Enter your Identity Number"
        value={formik.values.identityNumber}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.identityNumber && Boolean(formik.errors.identityNumber)}
        helperText={formik.touched.identityNumber && formik.errors.identityNumber}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <SearchButton
                color="info"
                variant="contained"
                onClick={onSearch}
                loading={loading}
                disabled={disableSearch}
                loadingPosition="start"
              >
                {!loading && <SearchIcon /> }
              </SearchButton>
            </InputAdornment>
          ),
        }}
      />
    </StyledGrid>
  );